/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_BestInputs */

const en_pricing_best = /** @type {(inputs: Pricing_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best value`)
};

const id_pricing_best = /** @type {(inputs: Pricing_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paling worth`)
};

/**
* | output |
* | --- |
* | "Best value" |
*
* @param {Pricing_BestInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pricing_best = /** @type {((inputs?: Pricing_BestInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_BestInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pricing_best(inputs)
	return en_pricing_best(inputs)
});